/**
 * @generated SignedSource<<1f3af46f2b6070c94a63c8366dcd9d26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AskFellowHooksRenameConversationMutation$variables = {
  conversationId: string;
  newTitle: string;
};
export type AskFellowHooksRenameConversationMutation$data = {
  readonly renameAskCopilotConversation: {
    readonly conversation: {
      readonly id: string;
      readonly title: string;
    };
  } | null;
};
export type AskFellowHooksRenameConversationMutation$rawResponse = {
  readonly renameAskCopilotConversation: {
    readonly conversation: {
      readonly id: string;
      readonly title: string;
    };
  } | null;
};
export type AskFellowHooksRenameConversationMutation = {
  rawResponse: AskFellowHooksRenameConversationMutation$rawResponse;
  response: AskFellowHooksRenameConversationMutation$data;
  variables: AskFellowHooksRenameConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "newTitle"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
      },
      {
        "kind": "Variable",
        "name": "newTitle",
        "variableName": "newTitle"
      }
    ],
    "concreteType": "RenameAskCopilotConversation",
    "kind": "LinkedField",
    "name": "renameAskCopilotConversation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AskCopilotConversation",
        "kind": "LinkedField",
        "name": "conversation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowHooksRenameConversationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AskFellowHooksRenameConversationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e070ada2d6ce3eca20384748dcb84662",
    "id": null,
    "metadata": {},
    "name": "AskFellowHooksRenameConversationMutation",
    "operationKind": "mutation",
    "text": "mutation AskFellowHooksRenameConversationMutation(\n  $conversationId: ID!\n  $newTitle: String!\n) {\n  renameAskCopilotConversation(conversationId: $conversationId, newTitle: $newTitle) {\n    conversation {\n      id\n      title\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc300471207e7b9c0712daac1d18aeb5";

export default node;
